import TestIds from 'constants/test-ids'
import MbcColumn from './MbcColumn'
import { MbcAssessmentNames } from 'types/Visit/MeasurementBasedCare'
import MemberIndication from './MemberIndication'
import Visit from 'types/Visit'
import { Observer } from 'mobx-react-lite'
import MbcAssessmentsChart from './MbcAssessmentsChart'
import classNames from '@ui-components-3/ui/lib/utils/classNames'

export type MeasurementBasedCareProps = {
  visit: Visit
  isPatientTab?: boolean
}

const MeasurementBasedCare = ({ visit, isPatientTab = false }: MeasurementBasedCareProps) => {
  const memberIndication = visit.intakes?.phq9?.emergencyWarning

  return (
    <div data-testid={TestIds.visits.measurementBasedCare.view}>
      {isPatientTab ? null : <p className="typography-caption text-neutral-500">Measurement based care</p>}

      <div className={`flex justify-start mt-4 gap-x-xl gap-y-m flex-wrap ${isPatientTab && 'flex-col mt-0'}`}>
        {visit.intakes?.gad7 ? (
          <MbcColumn title={MbcAssessmentNames.GAD_7} assessment={visit.intakes.gad7} isPatientTab={isPatientTab} />
        ) : null}
        {visit.intakes?.phq9 ? (
          <MbcColumn title={MbcAssessmentNames.PHQ_9} assessment={visit.intakes.phq9} isPatientTab={isPatientTab} />
        ) : null}
        {!!memberIndication && (
          <MemberIndication className={classNames('items-start', !isPatientTab && 'max-w-[200px]')}>
            <p className="text-[1em] text-[#6E727A] font-medium">MEMBER INDICATION</p>
            <MemberIndication.Banner />
          </MemberIndication>
        )}
      </div>
      {isPatientTab ? (
        <div data-testid={TestIds.visits.measurementBasedCare.previousMeasurements} className="pt-2">
          <Observer>
            {() =>
              visit.gad7Data?.currentPageSize ? (
                <MbcAssessmentsChart assessmentData={visit.gad7Data} displayData={visit.gad7Data.currentPage} />
              ) : null
            }
          </Observer>
          <Observer>
            {() =>
              visit.phq9Data?.currentPageSize ? (
                <MbcAssessmentsChart assessmentData={visit.phq9Data} displayData={visit.phq9Data.currentPage} />
              ) : null
            }
          </Observer>
        </div>
      ) : null}
    </div>
  )
}

export default MeasurementBasedCare
